import { Absent_getInstance3t0okspv6nz5y as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePairAssignmentsInputClass;
function SavePairAssignmentsInput() {
  if (SavePairAssignmentsInputClass === VOID) {
    class $ {
      constructor(partyId, pairingSetId, date, pairs, discordMessageId, slackMessageId) {
        discordMessageId = discordMessageId === VOID ? Absent_getInstance() : discordMessageId;
        slackMessageId = slackMessageId === VOID ? Absent_getInstance() : slackMessageId;
        this.k73_1 = partyId;
        this.l73_1 = pairingSetId;
        this.m73_1 = date;
        this.n73_1 = pairs;
        this.o73_1 = discordMessageId;
        this.p73_1 = slackMessageId;
      }
      toString() {
        return 'SavePairAssignmentsInput(partyId=' + this.k73_1.toString() + ', pairingSetId=' + this.l73_1.toString() + ', date=' + this.m73_1.toString() + ', pairs=' + toString(this.n73_1) + ', discordMessageId=' + toString(this.o73_1) + ', slackMessageId=' + toString(this.p73_1) + ')';
      }
      hashCode() {
        var result = this.k73_1.hashCode();
        result = imul(result, 31) + this.l73_1.hashCode() | 0;
        result = imul(result, 31) + this.m73_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.n73_1) | 0;
        result = imul(result, 31) + hashCode(this.o73_1) | 0;
        result = imul(result, 31) + hashCode(this.p73_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePairAssignmentsInput()))
          return false;
        if (!this.k73_1.equals(other.k73_1))
          return false;
        if (!this.l73_1.equals(other.l73_1))
          return false;
        if (!this.m73_1.equals(other.m73_1))
          return false;
        if (!equals(this.n73_1, other.n73_1))
          return false;
        if (!equals(this.o73_1, other.o73_1))
          return false;
        if (!equals(this.p73_1, other.p73_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePairAssignmentsInput');
    SavePairAssignmentsInputClass = $;
  }
  return SavePairAssignmentsInputClass;
}
//region block: exports
export {
  SavePairAssignmentsInput as SavePairAssignmentsInput3tgrc8c2zd524,
};
//endregion

//# sourceMappingURL=SavePairAssignmentsInput.mjs.map
